import { UpstoxAuthConfig, TokenResponse } from '../types/upstox';

export class UpstoxAuthService {
  private config: UpstoxAuthConfig;
  
  constructor(config: UpstoxAuthConfig) {
    this.config = config;
  }

  initiateAuth(state?: string) {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: this.config.clientId,
      redirect_uri: this.config.redirectUri,
      ...(state && { state })
    });

    // Ensure URL is properly encoded
    const encodedParams = params.toString().replace(/\+/g, '%20');
    window.location.href = `https://api.upstox.com/v2/login/authorization/dialog?${encodedParams}`;
  }

  async getAccessToken(code: string): Promise<TokenResponse> {
    const params = new URLSearchParams({
      code,
      client_id: this.config.clientId,
      client_secret: this.config.apiSecret,
      redirect_uri: this.config.redirectUri,
      grant_type: 'authorization_code'
    });

    try {
      console.log('Sending token request with params:', Object.fromEntries(params));
      const response = await fetch('https://api.upstox.com/v2/login/authorization/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: params
      });

      const data = await response.json();
      console.log('Token response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Failed to get access token');
      }

      return data;
    } catch (error) {
      console.error('Token request failed:', error);
      throw error;
    }
  }
}

export default UpstoxAuthService;
